export default function AffiliateIcon({ ...props }: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path
        stroke="currentColor"
        d="M6.02 3.877c.475-.318.975-.594 1.492-.825l-.203-.454.203.454c.793-.355 1.305-.581 1.743-.657.386-.068.707-.016 1.117.249.377.245.571.554.678 1.078.116.566.118 1.323.118 2.433v1.722c0 1.027 0 1.849.087 2.494.09.667.28 1.22.717 1.656.438.438.99.628 1.657.718.645.087 1.467.087 2.494.087h1.722c1.11 0 1.867.002 2.433.118.524.107.833.3 1.078.678.265.41.317.731.25 1.117-.077.438-.303.95-.658 1.743a10.165 10.165 0 01-5.389 5.238A10.169 10.169 0 016.02 3.877z"
      />
      <path
        fill="currentColor"
        d="M22.837 6.233a9.013 9.013 0 00-5.07-5.07c-1.731-.682-3.291.886-3.291 2.746v4.492c0 .62.502 1.123 1.123 1.123h4.491c1.861 0 3.43-1.56 2.747-3.291z"
      />
    </svg>
  );
}
